module.exports = __webpack_public_path__ + "webfonts/lg.woff";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.woff?n1z373
// module id = 521
// module chunks = 64 65